// 監視サイドバー: サマリ（ok/warn/danger 件数）＋ アラート一覧。
import AlertList from "./AlertList.jsx";
import { SIGNAL_LABEL_EN } from "../utils/labels.js";

function Sidebar({ counts, anomalies, onSelect, onClose }) {
  const c = counts ?? { ok: 0, warn: 0, danger: 0 };

  return (
    <aside className="sidebar">
      <div className="sidebar-head">
        <div>
          <p className="section-label">Monitoring</p>
          <h2 className="panel-title">監視サマリ</h2>
        </div>
        <button
          type="button"
          className="panel-collapse"
          onClick={onClose}
          title="閉じる"
          aria-label="監視パネルを閉じる"
        >
          «
        </button>
      </div>

      <div className="summary">
        <div className="summary-card is-danger">
          <span className="count">{c.danger}</span>
          <span className="name">{SIGNAL_LABEL_EN.danger}</span>
        </div>
        <div className="summary-card is-warn">
          <span className="count">{c.warn}</span>
          <span className="name">{SIGNAL_LABEL_EN.warn}</span>
        </div>
        <div className="summary-card is-ok">
          <span className="count">{c.ok}</span>
          <span className="name">{SIGNAL_LABEL_EN.ok}</span>
        </div>
      </div>

      <div className="alert-section">
        <div className="panel-heading" style={{ padding: 0, border: "none" }}>
          <p className="section-label">Alerts</p>
          <span className="count-badge">{anomalies?.length ?? 0}</span>
        </div>
        <AlertList anomalies={anomalies} onSelect={onSelect} />
      </div>
    </aside>
  );
}

export default Sidebar;
